<template>
  <fragment>
    <div v-if="showRotation" class="controls d-flex justify-start" v-bind:style="{ zoom: counterZoom }">
      <v-btn class="mr-2" color="primary" outlined fab small @click="rotate(-90)">
        <v-icon v-once>mdi-format-rotate-90</v-icon>
      </v-btn>
      <v-btn color="primary" outlined fab small @click="rotate(90)">
        <v-icon v-once style="transform: rotateY(180deg);">mdi-format-rotate-90</v-icon>
      </v-btn>
    </div>

    <div v-bind:style="{ transform: `rotate(${totalRotation}deg)` }">
      <canvas v-visible.once="drawPage" v-bind="canvasAttrs" ref="myCanvas"></canvas>
      <div
        id="text-layer"
        ref="textLayer"
        v-bind:style="{ top:textTop +'px',height:textHeight+'px',width:textWidth+'px'}"
        v-bind:class="{moveforeground:isPageFocused}"
      >
      <!--<PDFAnnotation v-for="a in documentLength" v-bind:key="'page:'+pageNumber+'.annotation'+a" v-bind="{annotation:pageAnnotations[a-1],totalHeight:textHeight,totalWidth:textWidth}">
      </PDFAnnotation>-->
        <template v-if="isPageFocused && permission.can_write">
          <PDFTextTag v-for="i in numTags" v-bind:key="i" v-bind="{annotation:taggedText[pageNumber-1][i-1], index:i-1,totalHeight:textHeight,totalWidth:textWidth}">
          </PDFTextTag>
        </template>
      </div>
    </div>
  </fragment>
</template>

<script>
import debug from "debug";
const log = debug("app:components/PDFPage");

import { PIXEL_RATIO, PIXEL_RATIO_DEVICE } from "../utils/constants";
import visible from "../directives/visible";
import { Fragment } from 'vue-fragment'
import PDFAnnotation from './PDFAnnotation'
import PDFTextTag from './PDFTextTag'
import { mapActions, mapGetters } from "vuex"

export default {
  components: { Fragment, PDFAnnotation, PDFTextTag },
  name: "PDFPage",
  data() {
    return {
      textLeft: 13,
      textTop: 0,
      textHeight: 1040,
      textWidth: 735,
    };
  },
  props: {
    page: {
      type: Object, // instance of PDFPageProxy returned from pdf.getPage
      required: true
    },
    scale: {
      type: Number,
      required: true
    },
    optimalScale: {
      type: Number,
      required: true,
      default: 1
    },
    isPageFocused: {
      type: Boolean,
      default: false
    },
    isElementFocused: {
      type: Boolean,
      default: false
    }
  },

  directives: {
    visible
  },

  computed: {
    counterZoom() {
      return 1 / this.zoom
    },
    totalRotation() {
      return this.globalRotation + (this.rotationPerDocument[this.pageNumber] || 0)
    },
    actualSizeViewport() {
      return this.viewport.clone({ scale: this.scale });
    },
    showRotation() {
      return this.inRotationMode && this.rotationMode === 'page'
    },
    canvasStyle() {
      let ratio = PIXEL_RATIO;
      if (this.permission.is_readonly) {
        ratio = PIXEL_RATIO_DEVICE;
      }
      const {
        width: actualSizeWidth,
        height: actualSizeHeight
      } = this.actualSizeViewport;
      const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight].map(
        dim => Math.ceil(dim / ratio)
      );
      return `width: ${pixelWidth}px; height: ${pixelHeight}px;`;
    },

    canvasAttrs() {
      let { width, height } = this.viewport;
      [width, height] = [width, height].map(dim => Math.ceil(dim));
      const style = this.canvasStyle;

      return {
        width,
        height,
        style,
        class: "pdf-page box-shadow"
      };
    },

    pageNumber() {
      return this.page.pageNumber;
    },

    pageAnnotations(){
      var result = this.$store.state.pageAnnotations[this.pageNumber-1];
      if(!result){
          result = []
      }
      return result
    },
    documentLength(){
      return this.pageAnnotations.length
    },
    numTags(){
      var result=0
      try{
        if (this.taggedText.length) {
          result = this.taggedText[this.pageNumber-1].length
        }
      }
      catch(e){} 
      return result
    },
    ...mapGetters({
      taggedText: "documents/taggedText",
      zoom: "documents/zoom",
      inRotationMode: "documents/inRotationMode",
      rotationMode: "documents/rotationMode",
      globalRotation: "documents/globalRotation",
      rotationPerDocument: "documents/rotationPerDocument",
      userData: 'me/userData',
      permission: 'permissions/permission'
    })
  },

  methods: {
    ...mapActions({
      doRotate: 'documents/doRotate',
    }),
    rotate(deg) {
      this.doRotate({page: this.pageNumber, rotation: deg})
    },
    focusPage() {
      if (this.isPageFocused) return;

      this.$emit("page-focus", this.pageNumber);
    },

    drawPage() {
      if (this.renderTask) return;

      const { viewport } = this;
      const canvasContext = this.$refs.myCanvas.getContext("2d");
      const renderContext = { canvasContext, viewport };

      // PDFPageProxy#render
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      this.renderTask = this.page.render(renderContext).promise;
      this.renderTask.then(() => {
        var that = this;
        this.page.getTextContent().then(function(textContent) {

          // PDF canvas
          //var pdf_canvas = $("#pdf-canvas");
          var pdf_canvas = that.$refs.myCanvas;

          // Canvas offset

          // Canvas height
          var canvas_height = viewport.height;
          // Canvas width
          var canvas_width = viewport.width;

          // Pass the data to the method for rendering of text over the pdf canvas.
          if (pdf_canvas) {
            that.textLeft = pdf_canvas.offsetLeft;
            that.textTop = pdf_canvas.offsetTop;  
          }
          
          that.textHeight = 1040; // canvas_height;
          that.textWidth = 735; // canvas_width;
          that.textHeight = canvas_height;
          that.textWidth = canvas_width;

          that.$store.dispatch('configuration/setCanvasDims', {
            height: that.textHeight,
            width: that.textWidth,
          }),

          import(
            /* webpackChunkName: 'pdfjs-dist' */
            "pdfjs-dist/webpack"
          )/*.then(pdfjs =>
            pdfjs.renderTextLayer({
              textContent: textContent,
              container: that.$refs.textLayer,
              viewport: viewport,
              textDivs: []
            })
          );*/

          that.$emit("page-rendered", {
            page: that.page,
            text: `Rendered page ${that.pageNumber}`
          });
        });
      }); /*
        .catch(response => {
          this.destroyRenderTask();
          this.$emit("page-errored", {
            response,
            page: this.page,
            text: `Failed to render page ${this.pageNumber}`
          });
        });*/
    },

    updateVisibility() {
      this.$parent.$emit("update-visibility");
    },

    destroyPage(page) {
      // PDFPageProxy#_destroy
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      if (page) page._destroy();

      this.destroyRenderTask();
    },

    destroyRenderTask() {
      if (!this.renderTask || !this.renderTask.promise) return;

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      this.renderTask.cancel();
      delete this.renderTask;
    }
  },

  watch: {
    scale: "updateVisibility",

    page(_newPage, oldPage) {
      this.destroyPage(oldPage);
    },

    isElementFocused(isElementFocused) {
      if (isElementFocused) this.focusPage();
    }
  },

  created() {
    // PDFPageProxy#getViewport
    // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
    this.viewport = this.page.getViewport({scale: this.optimalScale});
  },

  mounted() {
    log(`Page ${this.pageNumber} mounted`);
  },

  beforeDestroy() {
    this.destroyPage(this.page);
  }
};
</script>
<style>
.pdf-page {
  display: block;
  margin: 0 auto;
}
#text-layer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.9;
  line-height: 1;
  margin: 0 auto;
}

#text-layer > span   {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}

.moveforeground{
  z-index:10;
}
</style>

<style scoped>
::selection,
::-moz-selection {
  background: #cab7ff; /* WebKit/Blink Browsers/Gecko Browsers */
  color: transparent;
}
</style>